export enum OrdersTabParentState {
  CATALOG = 'management_catalog',
  MATERIAL = 'management_material',
  NULL = '',
}
